module.exports = __webpack_public_path__ + "static/media/i_salir.cbaf54cb.svg";